import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdminLinkSources',
  data () {
    return {
      isLoading: {
        clients: false,
        search: false
      },
      clients: [],
      selectedContentplanId: null,
      manualContentplanId: '',
      minScore: 0.35,
      limit: 200,
      results: [],
      selected: [],
      hasSearched: false,
      headers: [
        { text: 'Source domain', value: 'source_domain', width: '200px' },
        { text: 'Source page', value: 'source_url', sortable: false },
        { text: 'Score', value: 'score', width: '110px' },
        { text: 'Best matching target page', value: 'best_target_url', sortable: false }
      ]
    }
  },
  async mounted () {
    await this.loadClients()
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    isAdmin () {
      return !!this.user?.admin
    },
    clientItems () {
      return this.clients.map(client => ({
        text: `${client.contentplanName} (#${client.contentplanId})`,
        value: client.contentplanId
      }))
    },
    effectiveContentplanId () {
      const manual = parseInt(this.manualContentplanId)
      if (manual) return manual
      return this.selectedContentplanId
    }
  },
  methods: {
    ...mapActions([
      'adminContentplansOverviewGet',
      'adminLinkSourcesGet',
      'setSnackbar'
    ]),
    async loadClients () {
      this.isLoading.clients = true
      try {
        const response = await this.adminContentplansOverviewGet()
        this.clients = response || []
      } catch (error) {
        console.error('Error loading clients:', error)
      } finally {
        this.isLoading.clients = false
      }
    },
    async runSearch () {
      if (!this.effectiveContentplanId) {
        await this.setSnackbar({ open: true, text: 'Select a target client first', type: 'error' })
        return
      }
      this.isLoading.search = true
      this.selected = []
      try {
        const response = await this.adminLinkSourcesGet({
          contentplanId: this.effectiveContentplanId,
          limit: this.limit,
          minScore: this.minScore
        })
        this.results = response?.results || []
        this.hasSearched = true
      } catch (error) {
        console.error('Error finding link sources:', error)
        await this.setSnackbar({ open: true, text: 'Failed to find link sources', type: 'error' })
      } finally {
        this.isLoading.search = false
      }
    },
    exportSelected () {
      const rows = this.selected.length ? this.selected : this.results
      if (!rows.length) return
      const header = ['source_domain', 'source_title', 'source_url', 'score', 'best_target_title', 'best_target_url']
      const lines = [header.join(',')]
      rows.forEach(row => {
        lines.push([
          row.source_domain,
          row.source_title,
          row.source_url,
          row.score,
          row.best_target_title,
          row.best_target_url
        ].map(value => `"${String(value ?? '').replace(/"/g, '""')}"`).join(','))
      })
      const blob = new Blob([lines.join('\n')], { type: 'text/csv' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `link-sources-${this.effectiveContentplanId}.csv`
      link.click()
      URL.revokeObjectURL(url)
    },
    truncate (text, length = 70) {
      if (!text) return ''
      return text.length > length ? text.substring(0, length) + '...' : text
    }
  }
}
